module.exports = __webpack_public_path__ + "img/logo.896b98f8.png";